import { useParams } from "react-router";
import { TopBar } from "../components/TopBar";
import { meanField } from "../lib/stats";
import { useManifestStore } from "../state/manifestStore";

export function Users() {
  const { tenant } = useParams();
  const manifest = useManifestStore((s) => s.manifest);
  if (!manifest || !tenant) return null;
  const users = manifest.users.filter((u) => u.tenant === tenant);
  const sessions = manifest.sessions.filter((s) => s.tenant === tenant);

  return (
    <>
      <TopBar tenant={tenant} title="Users" />
      <div className="app-content">
        <div className="card">
          <table className="roster">
            <thead>
              <tr>
                <th>User</th>
                <th>Function</th>
                <th>Sessions</th>
                <th>Mean effort</th>
                <th>Mean success</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => {
                const us = sessions.filter((s) => s.user === u.id);
                const meanEffort = meanField(us, (s) => s.scores.human_effort);
                const meanSuccess = meanField(us, (s) => s.scores.overall_success);
                return (
                  <tr key={u.id}>
                    <td>{u.name}</td>
                    <td>{u.function}</td>
                    <td className="mono">{us.length}</td>
                    <td className="mono">{meanEffort}</td>
                    <td className="mono">{meanSuccess}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
